import type { pctDelta } from "@bookboost/shared/chart";

type DeltaResult = ReturnType<typeof pctDelta>;

interface DeltaProps {
  delta: DeltaResult;
  suffix?: string;
  invert?: boolean;
}

export function Delta({ delta, suffix, invert = false }: DeltaProps) {
  if (!delta) return null;
  const tone =
    delta.direction === "flat"
      ? "flat"
      : invert
        ? delta.direction === "up"
          ? "down"
          : "up"
        : delta.direction;
  return (
    <span className={`delta delta--${tone}`} title={`${delta.label}${suffix ? ` ${suffix}` : ""}`}>
      <span className="delta-arrow" aria-hidden>
        {delta.direction === "up" && (
          <svg width="8" height="8" viewBox="0 0 8 8">
            <path d="M4 2l3 3H1z" fill="currentColor" />
          </svg>
        )}
        {delta.direction === "down" && (
          <svg width="8" height="8" viewBox="0 0 8 8">
            <path d="M4 6L1 3h6z" fill="currentColor" />
          </svg>
        )}
        {delta.direction === "flat" && (
          <svg width="8" height="8" viewBox="0 0 8 8">
            <rect x="1" y="3.4" width="6" height="1.2" fill="currentColor" />
          </svg>
        )}
      </span>
      <span>{delta.label}</span>
      {suffix && <span className="delta-suffix">{suffix}</span>}
    </span>
  );
}
